/* Presentation-only enhancement. Native forms, physical IDs and keyed cart logic own state. */
(function () {
  var preference = matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = preference.matches;
  var observer;
  var active = new Set();
  var echoes = new Set();
  var pendingButtons = new Map();
  var cartFrames = new WeakMap();
  var ease = 'cubic-bezier(.16,1,.3,1)';

  function play(element, frames, duration, delay) {
    if (reduced || !element || !element.animate) return null;
    var animation = element.animate(frames, { duration: duration, delay: delay || 0, easing: ease });
    active.add(animation);
    animation.finished.then(function(){ active.delete(animation); }, function(){ active.delete(animation); });
    return animation;
  }
  function pulse(element) {
    play(element, [{ opacity: .5, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], 300);
  }
  function clearEffects() {
    active.forEach(function(animation){ animation.cancel(); });
    active.clear();
    echoes.forEach(function(node){ node.remove(); });
    echoes.clear();
    document.querySelectorAll('.motion-target,.is-depth-active').forEach(function(node){ node.classList.remove('motion-target','is-depth-active'); });
  }
  function echo(element, rect, kind) {
    if (reduced || !element || !rect.width || !element.animate) return;
    var copy = element.cloneNode(true);
    [copy].concat([].slice.call(copy.querySelectorAll('*'))).forEach(function(node){
      [].slice.call(node.attributes).forEach(function(attribute){
        if (attribute.name === 'id' || attribute.name === 'name' || attribute.name === 'href' || attribute.name.indexOf('data-') === 0 || attribute.name.indexOf('on') === 0) node.removeAttribute(attribute.name);
      });
      if (node.matches('input,button,select,textarea,a')) { node.tabIndex = -1; node.disabled = true; }
    });
    copy.classList.add('motion-echo',kind);
    copy.setAttribute('aria-hidden','true');
    copy.inert = true;
    Object.assign(copy.style, { position:'fixed', left:rect.left+'px', top:rect.top+'px', width:rect.width+'px', height:rect.height+'px', margin:'0', right:'auto', zIndex:'1200', pointerEvents:'none' });
    document.body.append(copy);
    echoes.add(copy);
    var animation = play(copy, [{ opacity:.85, transform:'translateY(0) scale(1)' }, { opacity:0, transform:'translateY(-8px) scale(.99)' }], kind === 'motion-nav-echo' ? 220 : 360);
    function remove(){ copy.remove(); echoes.delete(copy); }
    if (animation) animation.finished.then(remove,remove); else remove();
  }

  // Word choreography leaves original heading content and resting layout intact.
  var headline = document.querySelector('.manifesto h2');
  if (headline && !headline.children.length) {
    var text = headline.textContent;
    headline.setAttribute('aria-label',text);
    var fragment = document.createDocumentFragment();
    var word = 0;
    text.split(/(\s+)/).forEach(function(token){
      if (!token.trim()) fragment.append(document.createTextNode(token));
      else {
        var span = document.createElement('span');
        span.className = 'motion-word';
        span.textContent = token;
        span.setAttribute('aria-hidden','true');
        span.style.setProperty('--word-delay',Math.min(word++ * 38,380)+'ms');
        fragment.append(span);
      }
    });
    headline.replaceChildren(fragment);
  }
  document.querySelectorAll('.manifesto .wrap, .foot__top').forEach(function(element){ element.setAttribute('data-reveal',''); });
  document.querySelectorAll('.pcard[data-reveal]').forEach(function(element,index){ element.style.setProperty('--d',Math.min((index % 8)*65,260)+'ms'); });
  function setup(event) {
    reduced = (event ? event.matches : preference.matches) || document.documentElement.hasAttribute('data-reduce-motion');
    if (observer) observer.disconnect();
    if (reduced) clearEffects();
    var elements = document.querySelectorAll('[data-reveal]');
    document.body.classList.toggle('motion-ready',!reduced && 'IntersectionObserver' in window);
    if (reduced || !('IntersectionObserver' in window)) { elements.forEach(function(el){ el.classList.add('in'); }); return; }
    observer = new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if (entry.isIntersecting) { entry.target.classList.add('in'); observer.unobserve(entry.target); } }); }, {threshold:.08});
    elements.forEach(function(el){ if (!el.classList.contains('in')) observer.observe(el); });
  }
  setup();
  document.addEventListener('met:motionpreference',function(event){setup({matches:event.detail.reduced || preference.matches});});
  if (preference.addEventListener) preference.addEventListener('change',setup);

  // Open/close animations never delay native disclosure semantics or keyboard focus.
  document.querySelectorAll('[data-navigation-disclosure]').forEach(function(disclosure){
    var summary = disclosure.querySelector('summary');
    var panel = disclosure.querySelector('.nav__menu');
    if (!panel) return;
    function closeEcho(){ if (disclosure.open) echo(panel,panel.getBoundingClientRect(),'motion-nav-echo'); }
    summary.addEventListener('click',closeEcho);
    disclosure.addEventListener('keydown',function(event){ if (event.key === 'Escape') closeEcho(); },true);
    document.addEventListener('click',function(event){ if (disclosure.open && !disclosure.contains(event.target)) closeEcho(); },true);
    disclosure.addEventListener('toggle',function(){
      if (!disclosure.open) return;
      panel.querySelectorAll('a').forEach(function(link,index){ play(link,[{opacity:0,transform:'translateX(-8px)'},{opacity:1,transform:'translateX(0)'}],320,Math.min(index*32,160)); });
    });
  });

  // Pointer depth is bounded, fine-pointer only; layout is read once on entry.
  document.querySelectorAll('.pcard__media,.pdp__hero').forEach(function(frame){
    frame.setAttribute('data-motion-depth','');
    var bounds, raf, x=0, y=0;
    frame.addEventListener('pointerenter',function(event){
      if (reduced || event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      bounds = frame.getBoundingClientRect();
      frame.classList.add('is-depth-active');
    });
    frame.addEventListener('pointermove',function(event){
      if (!bounds || reduced) return;
      x = Math.max(-3,Math.min(3,((event.clientX-bounds.left)/bounds.width-.5)*6));
      y = Math.max(-3,Math.min(3,((event.clientY-bounds.top)/bounds.height-.5)*6));
      if (raf) return;
      raf = requestAnimationFrame(function(){ raf=null; frame.style.setProperty('--depth-x',x+'px'); frame.style.setProperty('--depth-y',y+'px'); });
    });
    frame.addEventListener('pointerleave',function(){ bounds=null; if(raf)cancelAnimationFrame(raf);raf=null;frame.classList.remove('is-depth-active');frame.style.removeProperty('--depth-x');frame.style.removeProperty('--depth-y'); });
  });
  var gallery = document.querySelector('.pdp__gallery');
  if (gallery) {
    var galleryTimer, previousImage = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
    gallery.addEventListener('scroll',function(){
      clearTimeout(galleryTimer);
      galleryTimer = setTimeout(function(){
        var index = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
        if (index === previousImage) return;
        previousImage = index;
        var image = gallery.querySelector('[data-slide="'+index+'"] img');
        play(image,[{opacity:.65},{opacity:1}],480);
      },90);
    },{passive:true});
  }

  document.addEventListener('met:variant-change',function(event){
    var section = event.target.closest('[data-product-section]');
    if (!section) return;
    pulse(section.querySelector('[data-product-price]'));
    pulse(section.querySelector('[data-product-status]'));
    section.querySelectorAll('[data-physical-option]:checked').forEach(function(input){
      var label = section.querySelector('label[for="'+input.id+'"]');
      play(label,[{transform:'scale(.97)'},{transform:'scale(1)'}],200);
    });
  });
  document.addEventListener('submit',function(event){
    var form = event.target;
    if (!form.matches('[data-product-form]') || event.defaultPrevented) return;
    var id = form.querySelector('[data-variant-id]'), button = form.querySelector('[data-product-add]');
    if (!id || id.disabled || !id.value || !button || button.disabled || !form.checkValidity()) return;
    if (!pendingButtons.has(button)) pendingButtons.set(button,button.textContent);
    button.setAttribute('aria-busy','true');
    button.classList.add('motion-submitting');
    if (button.dataset.pendingLabel) button.textContent = button.dataset.pendingLabel;
    play(button,[{transform:'scale(.985)'},{transform:'scale(1)'}],180);
  });

  document.addEventListener('met:cart:start',function(event){
    var section = event.target;
    var frames = new Map();
    section.querySelectorAll('[data-cart-line]').forEach(function(line){ frames.set(line.dataset.lineKey,{rect:line.getBoundingClientRect(),scrollY:scrollY,copy:event.detail.quantity === 0 && line.dataset.lineKey === event.detail.key ? line.cloneNode(true) : null}); });
    cartFrames.set(section,frames);
    var target = [].slice.call(section.querySelectorAll('[data-cart-line]')).find(function(line){return line.dataset.lineKey===event.detail.key;});
    if (target) target.classList.add('motion-target');
  });
  document.addEventListener('met:cart:success',function(event){
    var section = event.target, frames = cartFrames.get(section);
    if (frames) {
      if (event.detail.quantity === 0) {
        var removed = frames.get(event.detail.key);
        if (removed && removed.copy) {
          var rect = removed.rect;
          echo(removed.copy,{left:rect.left,top:rect.top+removed.scrollY-scrollY,width:rect.width,height:rect.height},'motion-cart-echo');
        }
      }
      section.querySelectorAll('[data-cart-line]').forEach(function(line){
        var prior = frames.get(line.dataset.lineKey);
        if (prior) {
          var delta = prior.rect.top+prior.scrollY-line.getBoundingClientRect().top-scrollY;
          if (Math.abs(delta)>1) play(line,[{transform:'translateY('+delta+'px)'},{transform:'translateY(0)'}],420);
        } else pulse(line);
      });
    }
    pulse(section.querySelector('[data-cart-subtotal]'));
    var changed = [].slice.call(section.querySelectorAll('[data-cart-line]')).find(function(line){return line.dataset.lineKey===event.detail.key;});
    if (changed) pulse(changed.querySelector('.co__item-price'));
    cartFrames.delete(section);
  });
  document.addEventListener('met:cart:error',function(event){
    event.target.querySelectorAll('.motion-target').forEach(function(line){line.classList.remove('motion-target');});
    pulse(event.target.querySelector('[data-cart-error]'));
    cartFrames.delete(event.target);
  });
  function restoreButtons(){ pendingButtons.forEach(function(text,button){ if(button.isConnected){button.textContent=text;button.removeAttribute('aria-busy');button.classList.remove('motion-submitting');} });pendingButtons.clear(); }
  addEventListener('pagehide',function(){ if(observer)observer.disconnect();clearEffects(); });
  addEventListener('pageshow',function(event){ if(event.persisted){restoreButtons();setup();} });
})();
